export default __webpack_public_path__ + "static/media/blue1.097dd98e.svg";